import * as React from "react"
import { SVGProps } from "react"
const NotAllowedIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={props?.width}
		height={props?.height}
		fill="none"
		{...props}
	>
		<path
			stroke="#C53762"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="m16.251 9.75-6.5 6.5m0-6.5 6.5 6.5M23.835 13c0 5.983-4.85 10.833-10.834 10.833-5.983 0-10.833-4.85-10.833-10.833 0-5.983 4.85-10.833 10.833-10.833 5.983 0 10.834 4.85 10.834 10.833Z"
		/>
	</svg>
)
export default NotAllowedIcon
